<template>
    <div :class="`threedotloader ${backgroundColor} ${className} ${extraClassName}`">
        <div class="threedotloader__dots absolute right-0 left-0">
            <div :class="`threedotloader__dot rounded-full inline-block ${dotColor}`"></div>
            <div :class="`threedotloader__dot rounded-full inline-block ${dotColor}`"></div>
            <div :class="`threedotloader__dot rounded-full inline-block ${dotColor}`"></div>
        </div>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps({
        dotColor: {
            type: String,
            default: 'bg-branding-brand-yellow',
        },
        backgroundColor: {
            type: String,
            default: 'bg-white',
        },
        className: {
            type: String,
            default: 'absolute inset-0 z-10 text-center',
        },
        extraClassName: {
            type: String,
            default: '',
        },
    });
</script>
